<!--自定义报表界面-->
<template>
	<div class="customizeReport-body">
		<div style="display: flex;padding-top:10px;align-items: center;">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
			<el-button type="primary" style='margin-left: 10px;' size='mini' @click="fileDownload()">下载<i class="el-icon-download el-icon--right"></i></el-button>
		</div>
		<el-scrollbar style="height:calc(100% - 56px);">
			<el-tree :data="fileList" show-checkbox node-key="id"  :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree">
				<span class="custom-tree-node" slot-scope="{node, data}">
			 	<img src="../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='directory'"/>
			 	<img src="../../../public/static/image/elTree/2.2.png" v-show="node.data.type=='file'"/>
			 	<span style="padding-left: 5px;">{{node.data.name}}</span>
				</span>
			</el-tree>
		</el-scrollbar>
	</div>
</template>
<script>
	import filedownloadTree from '../tree/filedownloadTree.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	export default {
		components: {
			filedownloadTree,
			iconButton
		},
		props: {},
		data() {
			return {
				fileList: [],
				filterText: '',
				defaultProps: {
					children: 'children',
					label: 'label'
				},
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.exportList()
		},
		destroyed() {},
		computed: {},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
		},
		methods: {
			exportList() {
				this.$store.cacheStore.state.load=true
				this.$api.reportApi.getCustomReportTree(respon => {
					//递归遍历所有next再排序
					this.digui([respon])
					this.fileList = downloadList([respon])
					this.$store.cacheStore.state.load=false
				})
			},
			digui(list){
				if(list!=[]&&list!=undefined){
					list.sort(this.compare("name"))
					list.forEach(item=>{
					if(!isempty(item.next)){
						this.digui(item.next)
					}
					})
				}
			},
			compare(name){
				return function(a,b){
					var s1 = a[name];
					var s2 = b[name];
					return s2.localeCompare(s1);
				}
			},
			nodeClick() {},
			filterNode(value, data) {
				if(!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			fileDownload() {
				let list = this.$refs.tree.getCheckedNodes()
				let urlList = []
				list.forEach(item => {
					if(item.type == 'file') {
						urlList.push(item)
					}
				})
				if(isempty(urlList)) {
					this.$message({
						message: '请选择文件',
						type: 'warning'
					})
				} else {
					for(var i = 0; i < urlList.length; i++) {
						saveAs(DWSystemSetting.downloadUrl + '/' + urlList[i].downLoadPath, urlList[i].name)
					}
				}

			}
		}
	}
</script>

<style>
	.customizeReport-body {
		margin: 0 auto;
		width: 95%;
		height: 100%;
		background-color: white;
	}
	
	.condition-body {
		width: 100%;
		height: 8%;
		display: flex;
		align-items: center;
	}
	
	.customizeReport-body .elTable1 {
		width: 95%;
		margin: 0 auto;
	}
	
	.customizeReport-body .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden;
	}
</style>